import { types, actions } from './requests'
export const DELETECOMMAND_TYPES = {
    ...types('DELETECOMMAND'),
}
export const DELETECOMMAND_ACTIONS = {
    ...actions('DELETECOMMAND'),
}